<template>
    <console-content max-width="1024">

        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">
                <span v-if="$route.params._member">회원상세</span>
                <span v-else>회원등록</span>
            </v-col>
            <v-spacer/>
        </v-row>

        <v-row class="mt-3">
            <v-col cols="12" md="8" class="py-0 pr-md-1">
                <v-card class="mx-1">
                    <v-card-title class="subtitle-2 font-weight-bold">기본정보</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="member.username" label="아이디" placeholder=" " hide-details class="col-12 col-md-6 pa-0" />

                        <v-row class="mt-4">
                            <v-col cols="12" md="6" class="py-0">
                                <v-password-field v-model="member.password" label="비밀번호" placeholder=" " hide-details />
                            </v-col>
                            <v-col cols="12" md="6" class="py-0 mt-3 mt-md-0">
                                <v-password-field v-model="member.subPassword" label="서브비밀번호" placeholder=" " hide-details />
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field v-model="member.name" label="이름" placeholder=" " hide-details />
                            </v-col>
                            <v-col cols="12" md="6" class="py-0 mt-3 mt-md-0">
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field v-model="member.phone" label="연락처" placeholder=" " hide-details />
                            </v-col>
                            <v-col cols="12" md="6" class="py-0 mt-3 mt-md-0">
                                <v-text-field v-model="member.email" label="이메일" placeholder=" " hide-details />
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field v-model="member.postcode" label="우편번호" placeholder=" " hide-details />
                            </v-col>
                            <v-col cols="12" md="6" class="py-0 mt-3 mt-md-0">
                            </v-col>
                        </v-row>
                        <v-row class="mt-4">
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field v-model="member.address1" label="기본주소" placeholder=" " hide-details />
                            </v-col>
                            <v-col cols="12" md="6" class="py-0 mt-3 mt-md-0">
                                <v-text-field v-model="member.address2" label="상세주소" placeholder=" " hide-details />
                            </v-col>
                        </v-row>

                        <v-textarea v-model="member.note" label="메모" placeholder=" " hide-details class="mt-4" />
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="4" class="py-0 pl-md-1">
                <v-card class="mx-1 mt-3 mt-md-0">
                    <v-card-title>
                        <span class="col-auto subtitle-2 pa-0">캐시 차단안함 / 차단</span>
                        <v-spacer/>
                        <v-switch v-model="member.isBlock" hide-details class="ma-0 pa-0"/>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>

        <v-card class="mx-1 mt-4">
            <v-card-title class="subtitle-2 font-weight-bold">
                상품권 과금설정 - Risk Management
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="4" class="py-0">
                        <v-select v-model="member.riskManagement.giftcard.level" :items="giftcardLevels" item-text="text" item-value="value" label="등급" placeholder=" " />
                    </v-col>
                </v-row>
                <v-row v-if="member.riskManagement.giftcard.level == 'exception'">
                    <v-col cols="12" md="4" class="py-0">
                        <v-text-field label="일일 구매한도(원)" placeholder=" " @input="value => member.riskManagement.giftcard.dailyLimit = parseInt(+value.replace(/[^0-9]/g, '') || 0)" :value="member.riskManagement.giftcard.dailyLimit.format()"/>
                    </v-col>
                    <v-col cols="12" md="4" class="py-0">
                        <v-text-field label="월간 구매한도(원)" placeholder=" " @input="value => member.riskManagement.giftcard.monthlyLimit = parseInt(+value.replace(/[^0-9]/g, '') || 0)" :value="member.riskManagement.giftcard.monthlyLimit.format()" />
                    </v-col>
                    <v-col cols="12" md="4" class="py-0">
                        <v-text-field v-model="member.riskManagement.giftcard.commission" label="구매 수수료(%)" placeholder=" " type="number" />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-row class="my-6">
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

    </console-content>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import { mdiMicrosoftExcel } from "@mdi/js";

import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";

export default {
    components: {
        ConsoleContent,
        VPasswordField
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            member: {
                username: null,
                password: null,
                subPassword: null,
                phone: null,
                email: null,

                postcode: null,
                address1: null,
                address2: null,

                riskManagement: {
                    giftcard: {
                        level: "normal",
                        dailyLimit: 10000000000,
                        monthlyLimit: 0,
                        commission: 0,
                    }
                }
            },

            giftcardLevels: [
                { text: "normal", value: "normal" },
                { text: "vip", value: "vip" },
                { text: "vvip", value: "vvip" },
                // { text: "예외", value: "exception" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            if(this.$route.params._member){
                let { member } = await api.console.members.get({ _id: this.$route.params._member });
                this.member = {
                    ...this.member,
                    ...member
                }
            }
        },
        validate(){
            try{
                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },
        async save(){
            if(this.validate()){
                this.$route.params._member 
                ? await api.console.members.put({
                    ...this.member,
                    password: this.member.password ? CryptoAES.encrypt(this.member.password) : undefined,
                    subPassword: this.member.subPassword ? CryptoAES.encrypt(this.member.subPassword) : undefined
                }) 
                : await api.console.members.post({
                    ...this.member,
                    password: this.member.password ? CryptoAES.encrypt(this.member.password) : undefined,
                    subPassword: this.member.subPassword ? CryptoAES.encrypt(this.member.subPassword) : undefined
                });

                alert("저장되었습니다");
                this.$router.go(-1);
            }
        },
        format(text){
            return (+(text?.toString() || "").replace(/[^0-9]/g, '') || 0).format();
        }
    }
}
</script>